import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { ArrowRight, FileText } from "lucide-react";

/**
 * Legacy payment result page. Online checkout (Stripe) is disabled for this
 * launch — Prime Suppliers are invoiced directly by Display America Accounting
 * from QuickBooks Online. This page is retained so old bookmarks or email
 * links don't 404; it points suppliers back to the Dashboard with the correct
 * expectations.
 */
export default function PaymentResult() {
  return (
    <Layout>
      <section className="container-summit py-24 max-w-xl text-center" data-testid="payment-disabled">
        <div className="overline mb-6"><span className="accent-rule" />Manual Invoicing</div>
        <h1 className="serif text-3xl sm:text-4xl">Online checkout is not required.</h1>
        <p className="mt-5 text-zinc-600 leading-relaxed">
          Display America Accounting will send your $2,500 Supplier Registration Fee invoice
          separately. Your Supplier Station stays reserved until payment is complete.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/dashboard" className="btn-black h-12 px-6" data-testid="payment-back-dashboard">
            Go to Supplier Dashboard <ArrowRight size={14} />
          </Link>
          <Link to="/documents" className="btn-outline-black h-12 px-5 text-xs inline-flex items-center gap-2" data-testid="payment-view-docs">
            <FileText size={14} /> Event Documents
          </Link>
        </div>
        <p className="mt-8 text-xs text-zinc-500">
          Questions? Email{" "}
          <a href="mailto:info@displayamerica.com" className="underline decoration-[#A39171] underline-offset-4">
            info@displayamerica.com
          </a>
          .
        </p>
      </section>
    </Layout>
  );
}
